import { RootState } from '../../store';

export const getIsModalOpenSelector = (state: RootState) => state.directoryReducer.isModalOpen;
